<template>
    <v-dialog
      v-model="visible"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h6">Transferir Locais</span>
        </v-card-title>
  
        <v-card-text>
          <p>Selecione a conta de destino para os locais selecionados:</p>
          <v-select
            v-model="targetAccount"
            :items="accountsList.data"
            item-text="account_name"
            item-value="name"
            label="Conta de destino"
            dense
            outlined
            clearable
            :loading="loadingAccounts"
          />
        </v-card-text>
  
        <v-card-actions>
            <v-btn text color="grey" @click="closeModal">Cancelar</v-btn>
            <v-btn color="primary" @click="transfer">Transferir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import { handleResponseError } from '@/api/handleError'

  export default {
    name: 'LocationTransferModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        selectedLocations: {
            type: Array,
            default: () => []
        }
    },
    data() {
      return {
        visible: this.value,
        loadingAccounts: false, 
        loading: false,
        targetAccount: null
      }
    },
    computed: {
        ...mapState({
        accountsList: state => state.accounts.all
    })
    },
    watch: {
      value(val) {
        this.visible = val
      },
      visible(val) {
        this.$emit('input', val)
      }
    },
    created() {
      this.fetchAccounts()
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async fetchAccounts() {
        this.loadingAccounts = true
        try {
            await this.$store.dispatch('accounts/getAccounts', { limit: 0 })
        } catch (error) {
            const message = handleResponseError(error, 'Ocorreu um erro ao buscar as contas.')
            this.$emit('notify', { text: message, color: 'red darken-2' })
        }
        this.loadingAccounts = false
      },
      transfer() {
        const payload = {
            locationIds: this.selectedLocations.map(loc => loc.id),
            newAccount: this.targetAccount,
        }
        this.loading = true

        this.$store
            .dispatch('locations/transferLocations', payload)
            .then(() => {
            this.$emit('notify', { text: 'Locais transferidos com sucesso!', color: 'green darken-2' })
            this.$emit('transferred')
            })
            .catch((error) => {
            const message = handleResponseError(error, 'Ocorreu um erro ao transferir as contas.')
            this.$emit('notify', { text: message, color: 'red darken-2' })
            })
            .finally(() => {
            this.loading = false
            this.closeModal()
            })
        }
    }
  }
  </script>
  